export default function status (state = {}, action) {
  switch (action.type) {
    case 'RESET_NOTIFICATION':
      return {}
    case 'NOTIFICATION_MESSAGE':
      return {
        ...state,
        timestamp: Date.now(),
        message: action.message,
        level: action.level,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/Notification/reducer.js